<template src="./template/index.html"></template>
<script>
import DibbleJS from "../../dibble";
import DibbleApi from "../../api";
import AddDiscountModal from "@/components/Discounts/AddDiscountModal/AddDiscountModal";

export default {
    name: 'Discounts',
    display: "Transition",
    data () {
        return {
            dibbleJs: DibbleJS,
            items: [],
            effective_ons: {},
            isShowAddDiscountModal: false,
            currentUpdateItem: null
        }
    },
    mounted () {
        this.getDiscountsList()
    },
    methods: {
        _onSuccess(response) {
            this.dibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                this.items = response.discounts;
                this.effective_ons = response.effective_ons;
            }
        },
        getDiscountsList() {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.getDiscountsList
            };
            this.dibbleJs.callApiRequest(params, this._onSuccess);
        },
        openModalUpdateDiscount (type, item = null) {
            this.isShowAddDiscountModal = true
            this.currentUpdateItem = item
        },
        discountAdded() {
            this.closeModal()
            this.getDiscountsList()
        },
        closeModal () {
            this.isShowAddDiscountModal = false
        },
    },
    components: {
        AddDiscountModal
    }
}
</script>
<style scoped>
tr.order-row {
    cursor: pointer;
}
tr.order-row:hover {
    background-color: #e1e1e1;
}
.btn-4 {
    margin-top: 0px;
}
.table th, .table td {
    vertical-align: middle !important;
}
</style>
